(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // const productSection = document.querySelector('[id^="ProductInfo-"]');
  // const stickyData = productSection.dataset.sticky;
  // if(stickyData === 'true') {
  //   var sidebarEl = document.querySelector('.sidebar__inner');
  //   var sidebar = new StickySidebar(sidebarEl, {
  //     topSpacing: 40,
  //     containerSelector: '.product__info-wrapper',
  //     innerWrapperSelector: '.sidebar__inner-padding',
  //     resizeSensor: true,
  //     minWidth: 992
  //   });
  //   sidebarEl.addEventListener('affix.bottom.stickySidebar', function (event) {
  //     console.log('Sidebar has stuck bottom of viewport.');
  //   });
  // }

  class Accordion {
    constructor(el) {
      this.el = el;
      this.summary = el.querySelector('summary');
      this.content = el.querySelector('.accordion__content');

      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.el.style.overflow = 'hidden';
      if (this.isClosing || !this.el.open) {
        this.open();
      } else if (this.isExpanding || this.el.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;

      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
      this.el.style.height = `${this.el.offsetHeight}px`;
      this.el.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.el.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.el.animate(
        {
          height: [startHeight, endHeight],
        },
        {
          duration: 400,
          easing: 'ease-out',
        }
      );
      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
      this.el.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.el.style.height = this.el.style.overflow = '';
      if (stickyData === 'true') {
        sidebar.updateSticky();
      }
    }
  }

  document.querySelectorAll('details.accordion__details').forEach((el) => {
    new Accordion(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  (() => {
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();
        
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          
          fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
              const html = new DOMParser().parseFromString(text, 'text/html');
              const recommendations = html.querySelector('product-recommendations');

              if (recommendations && recommendations.innerHTML.trim()) {
                this.innerHTML = recommendations.innerHTML;
                this.classList.add('product-recommendations--loaded');
              }
              
              if (html.querySelector('.swiper-slide')) {
                this.initializeSwiper();
              }
            })
            .catch(console.error);
        };

        new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' }).observe(this);
      }

      initializeSwiper() {
        new Swiper('.product-recommendations-slider', {
          slidesPerView: this.dataset.mobileSlides,
          spaceBetween: 15,
          slidesPerGroup: 1,
          autoHeight: false,
          observer: true,
          observeParents: true,
          parallax: true,
          navigation: {
            nextEl: '.recommendations-arrow .swiper-button-next',
            prevEl: '.recommendations-arrow .swiper-button-prev',
          },
          pagination: {
            el: '.recommendations-arrow .swiper-pagination',
            clickable: true
          },
          breakpoints: {
            991: { slidesPerView: this.dataset.desktopSlides, spaceBetween: 20 },
            600: { slidesPerView: 2.5, spaceBetween: 20 }
          }
        });
      }
    }
    customElements.define('product-recommendations', ProductRecommendations);
  })();

  } catch(e) { console.error(e); }
})();
})();
